// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nAbc","left":"styles_left__2i9Kj"};